import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { OperationInternalEvent } from './operation-internal-event'
import { OperationInternalEventSerializer } from './operation-internal-event.serializer'

@Injectable()
export class OperationInternalEventService extends ResourceService<OperationInternalEvent> {
  constructor(
    http: HttpClient,
    operationInternalEventSerializer: OperationInternalEventSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/operation-internal-events`,
      operationInternalEventSerializer
    )
  }
}
